import React, { useEffect, useRef, memo } from 'react';

const Video = memo(({ stream, id, muted, style }) => {
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Only update if stream actually changed
    if (streamRef.current !== stream) {
      streamRef.current = stream;
      
      if (stream) {
        videoElement.srcObject = stream;
        videoElement.playsInline = true;
        
        const playPromise = videoElement.play();
        if (playPromise !== undefined) {
          playPromise.catch(err => {
            console.log('Video play interrupted:', err);
          });
        }
      } else {
        videoElement.srcObject = null;
      }
    }
  }, [stream]); // Only dependency is stream object reference

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted={muted}
      style={style}
      className="rounded-lg"
      id={id}
    />
  );
});

Video.displayName = 'Video'; // For React DevTools
export default Video;